//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import userHeader from '~/components/login/userHeader.vue'
import wikiGeet from '~/components/common/wikiGeet.vue'
export default {
  components: {
    'user-header': userHeader,
    'wiki-geet': wikiGeet
  },
  props: {
    title: {
      type: String, default: '验证码'
    },
    phone: {
      type: [Number, String], default: '未传入手机号'
    },
    email: {
      type: String, default: ''
    },
    countOrnot: {
      type: Boolean, default: true
    },
    voiceState: {
      type: Boolean, default: true
    },
    isVercode: {
      type: Boolean, default: true
    },
    canIskip: { // 是否可以跳过
      type: Boolean, default: false
    }
  },
  data () {
    return {
      txtpass: { // 验证码
        one: '',
        two: '',
        tree: '',
        four: ''
      },
      product: 'bind', // 极验展示效果
      showDrag: false, // 是否展示极验拖拽框
      verCode: '', // 验证码
      obtainState: this.countOrnot, // 获取状态
      countDown: 0, // 倒计时秒数
      countimes: 0 // 倒计时次数
    }
  },
  computed: {
    // 手机号相关信息（国旗、手机区号、手机号等）
    phoneCode () {
      return this.$store.state?.phoneInfo || {}
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.obtainState) { // 是否倒计时
        this.countDown = 60
        this.startCount() // 开始倒计时
      }
      this.$refs?.txtpass1?.focus() // 获取焦点
    })
  },
  beforeDestroy () {
    clearTimeout(this.vTimer)
  },
  methods: {
    // 打开极验
    getweebgeet () {
      this.showDrag = true
    },
    // 极验成功后发送验证码
    sendVCode (data = {}) {
      this.showDrag = false
      this.countDown = 60
      this.obtainState = true // 展示语音验证码按钮
      this.startCount() // 开始倒计时
      this.$emit('getvericode', data)
    },
    // 开始倒计时
    getSms () {
      this.obtainState = true
      this.countDown = 60
      this.startCount() // 开始倒计时
      this.$refs?.txtpass1?.focus() // 获取焦点
    },
    // 验证码登录——开始倒计时
    startCount () {
      this.countDown--
      if (this.countDown < 1) { // 倒计时结束
        clearTimeout(this.vTimer)
        this.countimes++
        this.obtainState = false // 展示语音验证码按钮
        return true
      }
      this.vTimer = setTimeout(this.startCount, 1000)
    },
    // 第一个输入框事件
    verificcode1 () {
      const { one = '', two = '', tree = '', four = '' } = this.txtpass
      if (one != '' && two != '' && tree != '' && four != '') {
        this.verCode = one.concat(two, tree, four)
        this.$emit('getUsertion', this.verCode)
      }
      if (one != '') this.$refs?.txtpass2?.focus()
    },
    // 第二个输入框事件
    verificcode2 () {
      const { one = '', two = '', tree = '', four = '' } = this.txtpass
      if (one != '' && two != '' && tree != '' && four != '') {
        this.verCode = one.concat(two, tree, four)
        this.$emit('getUsertion', this.verCode)
      }
      if (two != '') this.$refs?.txtpass3?.focus()
    },
    // 第三个输入框事件
    verificcode3 () {
      const { one = '', two = '', tree = '', four = '' } = this.txtpass
      if (one != '' && two != '' && tree != '' && four != '') {
        this.verCode = one.concat(two, tree, four)
        this.$emit('getUsertion', this.verCode)
      }
      if (tree != '') this.$refs?.txtpass4?.focus()
    },
    // 第四个输入框事件
    async verificcode4 () {
      const { one = '', two = '', tree = '', four = '' } = this.txtpass
      if (one != '' && two != '' && tree != '' && four != '') {
        this.verCode = one.concat(two, tree, four)
        if (this.isVercode) { // 校验验证码是否正确
          try {
            const { succeed = false, extra = '' } = await this.$api.login.userVerifysms({ AreaCode: this.phoneCode?.code, PhoneNumber: this.phone, Smscode: this.verCode, ApplicationType: 7, ValidateSmsCodeType: 3, LanguageCode: this.currLangCode() })
            if (!succeed) return extra // 数据错误
          } catch (err) {}
        }
        this.$emit('getUsertion', this.verCode)
      }
      if (four != '') this.$refs?.txtpass4?.blur()
    }
  }
}
